<template>
  <el-dialog :visible="visible" :before-close="close" class="rounded-modal">
    <div class="donut-message">
      <svg-icon :icon="icon" class="donut-icon" />
    </div>
    <footer slot="footer" class="center-footer">
      <div class="status-message">
        {{ title }}
      </div>
      <div class="message" v-html="message"></div>
      <div :class="['buttonsGroup', { active: showButtons }]">
        <common-button class="wz-button" secondary @click="close">
          {{ $t('calendar.noMealWarnings.buttonDeny') }}
        </common-button>
        <common-button class="wz-button" primary @click="confirmChecked">
          {{ $t('calendar.noMealWarnings.buttonAccept') }}
        </common-button>
      </div>
    </footer>
  </el-dialog>
</template>

<script>
import SvgIcon from '@/components/SvgIcon';
import CommonButton from '@/components/common/CommonButton';

export default {
  name: 'ModalResponse',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    success: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    showButtons: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    SvgIcon,
    CommonButton,
  },
  computed: {
    icon() {
      const iconType = this.success ? 'success' : 'fail';
      return `donut-${iconType}`;
    },
  },
  methods: {
    close() {
      this.$emit('close');
      this.$emit('reverse-checked');
    },
    confirmChecked() {
      this.$emit('close');
      this.$emit('confirm-checked');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables';

.rounded-modal {
  background-color: $modal-background;

  /deep/ .el-dialog {
    width: 40%;
    padding-bottom: 30px;
    margin-top: 30vh !important;
    border-radius: 8px;
    border: $table-border-color;
  }

  /deep/ .el-dialog__headerbtn {
    &:hover {
      .el-icon-close {
        color: $light-gray;
      }
    }

    .el-icon-close {
      font-size: $modal-close-button-size;
      color: $light-gray;
    }
  }

  .donut-message {
    display: flex;
    justify-content: center;

    .donut-icon {
      width: 126px;
      height: 126px;
    }
  }

  .center-footer {
    text-align: center;
    font-size: $subtitle-font-size;

    .status-message {
      font-weight: bold;
    }
  }

  .buttonsGroup {
    display: none;
    margin-top: 15px;
    &.active {
      display: flex;
      justify-content: center;
    }
    .wz-button {
      margin: 0 7px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ModalResponse.vue